import {Component, EventEmitter, Input, Output} from '@angular/core';
import {PlayerConfigurationDefinition} from '../../../../models/player-config-list-option';

@Component({
  selector: 'storever-add-options-item',
  templateUrl: './add-options-item.component.html',
  styleUrls: ['./add-options-item.component.scss']
})
export class AddOptionsItemComponent {
  @Input() playerConfDef: PlayerConfigurationDefinition;
  @Output() addOptionItem = new EventEmitter<PlayerConfigurationDefinition>();



  constructor() { }

  addOption(item: PlayerConfigurationDefinition): void {
   this.addOptionItem.emit(item)
  }
  replace(value: string): string {
    return value.replace(/\./g, '');
  }
}
